import React from 'react'
import gql from 'graphql-tag'
import {Table} from 'antd'
import {PaperClipOutlined} from '@ant-design/icons'
import {formatPrice, addVat} from 'lib/util'
import Query from 'components/shared/Query'
import Heading from 'components/shared/Heading'

const orderQuery = gql`
  query OrderQuery($id: ID!) {
    order(id: $id) {
      id
      total
      invoiceLines {
        id
        bundleId
        itemNo
        itemUnit
        unitPrice
        quantity
        description
        attachments
        state
      }
      invoiceRecipient {
        name
        streetAddress
        postalCode
        postalArea
      }
    }
  }
`

const OrderLines = ({order}) => {
  const lines = order.invoiceLines.map((line) => ({
    key: line.id,
    itemNo: line.itemNo,
    description: line.bundleId ? `${line.description} (pakke)` : line.description,
    quantity: `${line.quantity} ${line.itemUnit}`,
    total: formatPrice(line.quantity * line.unitPrice),
    state: line.state,
    attachments: (
      <>
        {line.attachments.map((attachment, i) => (
          <a
            key={i}
            href={attachment}
            target="_blank"
            rel="noopener noreferrer"
            title="Vedlegg"
          >
            <PaperClipOutlined />
          </a>
        ))}
      </>
    )
  }))

  return (
    <Table
      className="order-lines"
      dataSource={lines}
      rowClassName={(record) => record.state === 'cancelled' ? 'cancelled' : ''}
      columns={[
        {title: 'Varekode', dataIndex: 'itemNo', key: 'itemNo'},
        {title: 'Beskrivelse', dataIndex: 'description', key: 'description'},
        {title: 'Antall', dataIndex: 'quantity', key: 'quantity'},
        {title: 'Totalpris', dataIndex: 'total', key: 'total', className: 'price'},
        {title: '', dataIndex: 'attachments', key: 'attachments'},
      ]}
    />
  )
}

const OrderTotals = ({order}) => {
  return (
    <div className="order-totals">
      <div className="row">
        <span>Sum</span>
      </div>
      <div className="row">
        <span>Eks. mva</span>
        <span>{formatPrice(order.total)}</span>
      </div>
      <div className="row inc-vat">
        <span>Ink. mva</span>
        <span>{formatPrice(addVat(order.total))}</span>
      </div>
    </div>
  )
}

const InvoiceRecipient = ({order}) => {
  const {name, streetAddress, postalCode, postalArea} = order.invoiceRecipient
  return (
    <div className="invoice-recipient">
      <Heading level={3}>Faktura sendes til</Heading>
      <span>{name}</span>
      <span>{streetAddress}</span>
      <span>{postalCode} {postalArea}</span>
    </div>
  )
}

const List = ({match}) => {
  return (
    <div className="orders show">
      <Heading level={2}>Se ordre</Heading>

      <Query
        inlineLoading
        inlineError
        query={orderQuery}
        variables={{
          id: match.params.orderId,
        }}
      >
        {({getData}) => {
          const order = getData('order')

          return (
            <>
              <InvoiceRecipient order={order} />
              <OrderTotals order={order} />
              <OrderLines order={order} />
            </>
          )
        }}
      </Query>
    </div>
  )
}

export default List
